/**
 * WordPress dependencies
 */
import { useMemo } from '@safe-wordpress/element';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { getEditorSettings, SpacingSize } from '../../../utils';
import { RANGE_CONTROL_MAX_SIZE } from '../utils';

const EMPTY_ARRAY: Array< SpacingSize > = [];

// eslint-disable-next-line @typescript-eslint/unbound-method
const compare = new Intl.Collator( 'und', { numeric: true } ).compare;

export default function useSpacingSizes(): Array< SpacingSize > {
	const settings = getEditorSettings();
	const customSpacingSizes = settings.spacing.spacingSizes.custom;
	const themeSpacingSizes = settings.spacing.spacingSizes.theme;
	const defaultSpacingSizes = settings.spacing.spacingSizes.default;
	const defaultSpacingSizesEnabled = settings.defaultSpacingSizes;

	const customSizes = customSpacingSizes ?? EMPTY_ARRAY;

	const themeSizes = themeSpacingSizes ?? EMPTY_ARRAY;

	const defaultSizes =
		defaultSpacingSizes && defaultSpacingSizesEnabled !== false
			? defaultSpacingSizes
			: EMPTY_ARRAY;

	return useMemo( () => {
		const sizes = [
			{
				name: _x( 'None', 'text', 'nelio-ab-testing' ),
				slug: '0',
				size: '0',
			},
			...customSizes,
			...themeSizes,
			...defaultSizes,
		];

		// Using numeric slugs opts-in to sorting by slug.
		if ( sizes.every( ( { slug } ) => /^[0-9]/.test( slug ) ) ) {
			sizes.sort( ( a, b ) => compare( a.slug, b.slug ) );
		}

		return sizes.length > RANGE_CONTROL_MAX_SIZE
			? [
					{
						name: _x( 'Default', 'text', 'nelio-ab-testing' ),
						slug: 'default',
						size: '',
					},
					...sizes,
			  ]
			: sizes;
	}, [ customSizes, themeSizes, defaultSizes ] );
}
